/* eslint-disable react/forbid-foreign-prop-types */
import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import "./MultiTrackMediaPlayerWidget.css";
import Widget from "../Widget";

import ReactPlayer from "react-player";
import { Button, Input } from "semantic-ui-react";

class MultiTrackMediaPlayerWidget extends Widget {
  static propTypes = {
    ...Widget.propTypes,
    align: PropTypes.string,
    justify: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static getDefaultConfig = () => {
    return {
      align: "align-left",
      justify: false,
    };
  };

  handleVideoSeek = (seconds) => {
    this.setState({ progress: seconds });
    this.state.audioRefs.forEach((audioPlayer) =>
      audioPlayer.current.seekTo(seconds, "seconds"),
    );
  };

  updateDuration = (index, value) => {
    const newDurations = this.state.audioDurations.map((c, i) => {
      if (i === index) {
        return value;
      } else {
        return c;
      }
    });
    this.setState({ audioDurations: newDurations });
  };

  updateVolumes = (index, value) => {
    const widgetVal = _.cloneDeep(this.props.value);
    let newValue = parseInt(value);
    if (!(newValue && newValue <= 100 && newValue >= -100)) {
      newValue = 0;
    }

    const newVolumes = this.state.audioVolumes.map((c, i) => {
      if (i === index) {
        return newValue;
      } else {
        return c;
      }
    });
    widgetVal.volumes = newVolumes;
    this.setState({ audioVolumes: newVolumes }, this.update(widgetVal));
  };

  updateSolo = (index) => {
    let newSoloMode = this.state.soloMode;
    const newSolo = this.state.audioSolo.map((c, i) => {
      if (i === index) {
        newSoloMode = !c;
        return newSoloMode;
      } else {
        return false;
      }
    });
    this.setState({ audioSolo: newSolo, soloMode: newSoloMode });
  };

  updateReset = (index) => {
    const newReset = this.state.resetVolumes.map((c, i) => {
      if (i === index) {
        return !c;
      } else {
        return c;
      }
    });
    this.setState({ resetVolumes: newReset });
  };

  resetAll = () => {
    this.setState({ resetVolumesBackup: [...this.state.resetVolumes] });
    const newReset = this.state.resetVolumes.map(() => true);
    this.setState({ resetVolumes: newReset, compareClicked: true });
  };

  disableResetAll = () => {
    this.setState({ resetVolumes: [...this.state.resetVolumesBackup], compareClicked: false });
  };

  updateLabels = (index, value) => {
    const widgetVal = _.cloneDeep(this.props.value);
    const newLabels = this.state.audioLabels.map((c, i) => {
      if (i === index) {
        return value;
      } else {
        return c;
      }
    });
    widgetVal.audio_labels = newLabels;
    this.setState({ audioLabels: newLabels }, this.update(widgetVal));
  };

  applyGainCorrection = (volume, correction) => {
    if (volume <= 0) {
      const multiplier = (volume + 100) / 100;
      return correction * multiplier;
    } else {
      const multiplier = volume / 100;
      return correction + multiplier * (1 - correction);
    }
  };

  constructor(props) {
    super(props);
    const widgetVal = props.value || {};
    const audio_urls = widgetVal.audio_urls || [];
    const questionVals = props.questionVals ? props.questionVals[props.componentId] : {};
    this.state = {
      playing: false,
      progress: 0.0,
      audioRefs: audio_urls.map(() => React.createRef()),
      audioDurations: audio_urls.map(() => 0.0),
      audioLabels: widgetVal.audio_labels || audio_urls.map(() => ""),
      audioVolumes: widgetVal.volumes || audio_urls.map(() => 0),
      originalVolumes:
        _.cloneDeep(questionVals.volumes) || audio_urls.map(() => 0),
      resetVolumes: audio_urls.map(() => false),
      resetVolumesBackup: audio_urls.map(() => false),
      compareClicked: false,
      audioSolo: audio_urls.map(() => false),
      soloMode: false,
    };
  }

  componentDidMount() {
    this.registerEmptyValid();
  }

  isValid = () => {
    return true;
  };

  isEmpty = () => {
    return false;
  };

  render() {
    const widgetConfig = _.cloneDeep(this.props.widgetConfig);
    const widgetVal = this.props.value ? _.cloneDeep(this.props.value) : {};

    const muteVideo = widgetConfig.muteVideo || false;
    const customClasses = `${widgetConfig.align} ${muteVideo ? "MutedVideo" : ""}`;
    const videoUrl = widgetVal.video_url || "empty_url";
    const audioUrls = widgetVal.audio_urls || [];
    const width = widgetConfig.width || 640;
    const height = widgetConfig.height || 480;
    const labelMaxLength = widgetConfig.labelMaxLength || 120;
    const labelReadOnly = widgetConfig.labelReadOnly || false;
    const gainCorrection = widgetConfig.gainCorrection
      ? 10 ** (parseFloat(widgetConfig.gainCorrection) / 20)
      : 0.5;

    let player = audioUrls
      ? audioUrls.map((url, index) => (
          <div className={`TrackRow ${customClasses}`} key={index}>
            <ReactPlayer
              controls={false}
              className={`HiddenAudioPlayer`}
              url={url}
              playing={
                this.state.playing &&
                this.state.audioDurations[index] >= this.state.progress
              }
              onDuration={(d) => {
                this.updateDuration(index, d);
              }}
              volume={this.applyGainCorrection(
                this.state.resetVolumes[index]
                  ? this.state.originalVolumes[index]
                  : this.state.audioVolumes[index],
                gainCorrection,
              )}
              muted={
                this.state.soloMode && !this.state.audioSolo[index]
                  ? true
                  : false
              }
              ref={this.state.audioRefs[index]}
            />
            <Input
              value={this.state.audioLabels[index] || ""}
              disabled={labelReadOnly}
              style={{ width: `${labelMaxLength}px` }}
              onChange={(e, d) => this.updateLabels(index, d.value)}
              className="TrackLabel"
              type="text"
            />
            <Input
              type="range"
              min="-100"
              max="100"
              step="1"
              size={"small"}
              value={
                this.state.resetVolumes[index]
                  ? this.state.originalVolumes[index]
                  : this.state.audioVolumes[index]
              }
              onChange={(e, d) => this.updateVolumes(index, d.value)}
              disabled={this.state.resetVolumes[index]}
              className={"VolumeSlider"}
            />
            <Input
              type="number"
              min="-100"
              max="100"
              step="1"
              value={
                this.state.resetVolumes[index]
                  ? this.state.originalVolumes[index]
                  : this.state.audioVolumes[index]
              }
              onChange={(e, d) => this.updateVolumes(index, d.value)}
              disabled={this.state.resetVolumes[index]}
              className="VolumeInput"
            />
            <Button
              content={"Solo"}
              className="datahive-button"
              color={this.state.audioSolo[index] ? "yellow" : "grey"}
              onClick={() => this.updateSolo(index)}
            />
            <Button
              content={"Reset"}
              className="datahive-button"
              color={this.state.resetVolumes[index] ? "yellow" : "grey"}
              onClick={() => this.updateReset(index)}
            />
          </div>
        ))
      : undefined;

    let videoPlayer = (
      <ReactPlayer
        controls
        muted={muteVideo}
        className={`player MultiTrackPlayer ${customClasses}`}
        width={width + "px"}
        height={height + "px"}
        url={videoUrl}
        playing={this.state.playing}
        onSeek={(sec) => this.handleVideoSeek(sec)}
        onPlay={() => this.setState({ playing: true })}
        onPause={() => this.setState({ playing: false })}
        onEnded={() => this.setState({ playing: false, progress: 0.0 })}
        onProgress={(s) => this.setState({ progress: s.playedSeconds })}
      />
    );

    let resetAllButton = (
      <Button
        className="datahive-button ResetAllButton"
        onMouseDown={this.resetAll}
        onMouseUp={this.disableResetAll}
        onMouseLeave={this.state.compareClicked ? this.disableResetAll: undefined}
        content={"Compare"}
      />
    );

    return (
      <div className={"MediaPlayerWidget Widget"}>
        {videoPlayer}
        {player}
        {resetAllButton}
      </div>
    );
  }
}

export default MultiTrackMediaPlayerWidget;
